import { compose, filter, isNil, map } from 'lodash/fp';
import { Device, IntegrationRedirect } from '@mews-commander/legacy-data-structures';
import { openInBrowserTab } from '@mews-commander/utils';
import { actionsFactory } from '../factory/actions';
import { reducersFactory, selectorsFactory } from '../factory/reducers';
import { PASSPORT_SCANNER_INTEGRATIONS_FETCH } from '../actions/constants';

export const NAME = 'passportScannerIntegrations';

export const openPassportScannerInBrowserTab = (url: $TSFixMe, reservationId: $TSFixMe) =>
    openInBrowserTab(`${url}?reservationid=${reservationId}`);

const { passportScannerIntegrationsReducer } = reducersFactory({
    name: NAME,
    baseAction: PASSPORT_SCANNER_INTEGRATIONS_FETCH,
});
export default passportScannerIntegrationsReducer;

export const { getPassportScannerIntegrations, isFetching, getLastUpdated } = selectorsFactory({
    name: NAME,
    entityMapper: ({ scanners, integrations }: $TSFixMe) => [
        ...toDevices(scanners),
        ...getIntegrationRedirects(integrations),
    ],
});

export const { fetchPassportScannerIntegrations } = actionsFactory({
    baseAction: PASSPORT_SCANNER_INTEGRATIONS_FETCH,
    name: NAME,
    lastUpdateSelector: getLastUpdated,
});

const toDevices = map(Device);
const getIntegrationRedirects = compose(
    filter((i) => !isNil((i as $TSFixMe).url)),
    map(IntegrationRedirect)
);
